import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../utils';

export interface PreviewImageOption extends Partial<GeneralInvokeOption> {
  urls: Array<string>;
  current: string;
}

/**
 * js
 * ma.previewImage({
  urls: [],
  current: '',
  success() {},
  fail() {},
  complete() {}
});
*/

// 预览图片
export function previewImage(option: PreviewImageOption) {
  if (!option?.urls) {
    return logErrorAndRunFail(
      APINames.Native.PREVIEW_IMAGE,
      option,
      'parameter error:parameter.urls should be Array instead of Undefined.'
    );
  }
  return MacleJSBridge.beforeInvoke(APINames.Native.PREVIEW_IMAGE, option);
}
